var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customcheckerboard-top-nav"
  }, [_c('div', {
    attrs: {
      "slot": "top-left"
    },
    slot: "top-left"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isBackButtonVisible,
      expression: "isBackButtonVisible"
    }],
    class: ['customcheckerboard-top-nav-back', {
      'customcheckerboard-top-nav-back-text': _vm.isBackButtonAsText
    }, {
      disabled: !_vm.enableControls
    }],
    attrs: {
      "type": "button",
      "title": "Back"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm.isBackButtonAsText ? _c('span', [_vm._v(_vm._s(_vm.translations.vctBackButtonAsText))]) : _c('span', {
    staticClass: "icon-arrow-left-indicator-open"
  })])]), _c('div', {
    staticClass: "customcheckerboard-top-nav-center"
  }, [_c('div', {
    staticClass: "customcheckerboard-top-nav-logo"
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/images/common/customs_logo_red.png"),
      "alt": ""
    }
  })]), _c('div', [_c('h2', {
    staticClass: "customcheckerboard-top-nav-title"
  }, [_vm._v(_vm._s(_vm.translations.customChekerboardTitle))])])]), _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    class: ['customcheckerboard-top-nav-close', {
      disabled: !_vm.enableControls
    }],
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }